import React from 'react';
import { connect } from 'react-redux';
import { t, Trans } from '@lingui/macro';
import { withI18n } from "@lingui/react";
import { Col, Form, Input, Row } from 'antd';
import CountrySelect from 'bukku/components/Select/Country';

function Address() {
    return (
        <Row gutter={[0, 4]}>
            <Col span={24}>
                <Form.Item name="deliveryStreet" label={<Trans>Shipping Address</Trans>} className="pack">
                    <Input.TextArea
                        placeholder={t`Street Address`}
                        autoSize={{ minRows: 2, maxRows: 3 }}
                    />
                </Form.Item>
            </Col>

            <Col xs={24}>
                <Row type="flex" gutter={8}>
                    <Col span={12}>
                        <Form.Item name="deliveryCity">
                            <Input
                                placeholder={t`City`}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item name="deliveryState">
                            <Input
                                placeholder={t`State`}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>

            <Col xs={24}>
                <Row type="flex" gutter={8}>
                    <Col span={12}>
                        <Form.Item name="deliveryPostcode">
                            <Input
                                placeholder={t`Postcode`}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item name="deliveryCountryCode">
                            <CountrySelect
                                allowClear
                                popupClassName="w250"
                                placeholder={t`Country`}
                                popupContainerId="parentElement"
                                placement="bottomRight"
                                isPublic
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default connect(() => ({

}), {

})(withI18n()(Address));
